.backButtonIcon {
  border-radius: 20px;
}

.backButtonIcon:hover {
  circle {
    fill: #def3ff;
  }
}

.backButtonIcon:active {
  circle {
    fill: none;
    stroke: #e1f4ff;
  }
}

.revertIcon {
  cursor: pointer;
}

.searchIcon {
  cursor: pointer;
}
